<script setup lang="ts">
import DriverGauge from './parts/DriverGauge.vue';
import EmptyStateIconUrl from '@Shared/components/visuals/visualAssets/EmptyState_Icon.svg?url';
defineProps<{
  hasNoData?: boolean;
  isFrontline: boolean;
  inPopup: boolean;
  title?: string;
}>();

const emit = defineEmits<{
  (event: 'showDetails'): void;
}>();
</script>
<template>
  <div class="relative h-full flex flex-col rounded-[8px]" :class="{ 'bg-[#F9FAFB] pb-4 2xl:pb-0': !isFrontline }">
    <div
      v-if="hasNoData && !isFrontline"
      class="absolute top-45% left-0 text-center w-full text-[#828282] text-sm xl:text-3 2xl:text-4.5 3xl:text-9 3xl:line-height-3rem font-bold"
    >
      There are no new responses. <br />Please check again later.
    </div>
    <div
      v-if="hasNoData && isFrontline && !inPopup"
      class="xs:text-4 xs:line-height-1.5rem absolute top-35% left-0 text-center w-full text-[#828282] xl:text-3 font-family[Roboto] xl:line-height-1rem"
    >
      <img :src="EmptyStateIconUrl" alt="" />
      <div class="xs:max-w-[240px] xl:max-w-[200px] m-auto">
        <span>
          Nothing to see here. <br />
          You can try changing the <strong>filter</strong> or checking the <strong>View More</strong> to see other
          programs.
        </span>
      </div>
    </div>
    <div
      v-if="!inPopup"
      class="flex items-center font-bold xl:text-4 2xl:text-5 3xl:text-10 3xl:mt-8 xs:text-5 font-family[Poppins] text-[#4F4F4F]"
      :class="{
        'ml-0 pt-5 pb-5': isFrontline,
        'ml-4 2xl:ml-6 3xl:ml-10 mb-2 mt-2 mr-4 2xl:mt-4 2xl:mb-10 3xl:mt-8 3xl:mb-17': !isFrontline,
      }"
    >
      <div class="inline-block">
        <div v-if="title">
          {{ title }}
        </div>
        <div v-else class="inline-block loading-gradient h-50% w-33% rounded-2"></div>
      </div>
      <a
        v-if="isFrontline"
        id="show-driver-modal-button"
        @click="emit('showDetails')"
        class="text-3 mr-4 color-[#C73362] font-400 font-[Roboto] underline ml-auto lg:inline xs:hidden cursor-pointer"
      >
        View More
      </a>
      <a
        v-if="isFrontline"
        id="show-driver-modal-button-mobile"
        @click="emit('showDetails')"
        class="lg:hidden inline ml-auto i-mdi-chevron-right bg-[#4F4F4F] cursor-pointer"
        style="width: 2rem; height: 2rem"
      >
      </a>
    </div>
    <div class="flex items-center xs:flex-col lg:flex-row" :class="{ 'xs:h-100% lg:h-[150px]': isFrontline }">
      <DriverGauge title="STRONGEST" :inPopup="inPopup" />
      <DriverGauge title="LOSING STRENGTH" :inPopup="inPopup" />
      <DriverGauge title="WEAKEST" :inPopup="inPopup" />
    </div>
  </div>
</template>
<style scoped>
.loading-gradient {
  border-radius: 20px;
}
</style>
